module.exports = __webpack_public_path__ + "img/oaknest-12.62494da9.jpeg";